import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { TranslateService } from '@ngx-translate/core';

import { locale as english } from './../i18n/en';
import { locale as espanol } from './../i18n/es';

import { MinkaLoginService } from '../minka-login.service';
import { FuseTranslationLoaderService } from '../translation-loader.service';

const APP_ID = 4;
@Component({
    selector: 'app-recuperarclave',
    templateUrl: './recuperarclave.component.html',
    styleUrls: ['./recuperarclave.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class RecuperarclaveComponent implements OnInit {
  formRecoveryPass:FormGroup;
  constructor(
    private _minkaService: MinkaLoginService,

    public _translate : TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
        
    
        this._translate.addLangs(['en','es']);
        if(localStorage.getItem("idioma")){
            this._translate.setDefaultLang(localStorage.getItem("idioma"));
            this._translate.use(localStorage.getItem("idioma"));
        }else{
            this._translate.setDefaultLang('es');
            this._translate.use('es');
        }
        
        this._fuseTranslationLoaderService.loadTranslations(english, espanol);
   }

  ngOnInit(): void {
    this.formRecoveryPass = new FormGroup({
        email : new FormControl('', Validators.required),
        dni: new FormControl('', Validators.required)
    });
  }

  enviar(){
      let obj={
          correo: this.formRecoveryPass.controls.email.value,
          documento: this.formRecoveryPass.controls.dni.value,
          app_id: APP_ID,
      }

      this._minkaService.httpPost('api/usuario/reset', obj).subscribe(response=>{
       
      })
  }

}
